module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'me23afce',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
